{
  "schemaVersion": 1,
  "slug": "resend",
  "name": "Resend",
  "description": "Connect Resend's provider-hosted MCP server.",
  "categories": [
    "communication"
  ],
  "featured": false,
  "branding": {
    "logoUrl": "/brands/apps/resend.svg",
    "darkLogoUrl": "/brands/apps/resend-dark.svg"
  },
  "urlPatterns": [
    "https://mcp.resend.com/*"
  ],
  "docsUrl": "https://resend.com/changelog/remote-mcp-server",
  "redirectConstraints": "https-or-loopback-http",
  "methods": [
    {
      "key": "mcp-oauth",
      "transport": "mcp_remote",
      "auth": "oauth",
      "ownershipModes": [
        "dcr"
      ],
      "whenToUse": "Use browser sign-in for the provider-hosted MCP server.",
      "defaults": {
        "serverUrl": "https://mcp.resend.com/mcp"
      },
      "guidanceMd": "Connect Resend in the browser. A Resend account with access to the relevant domains.",
      "riskTier": "S3",
      "label": "Sign in with Resend",
      "consoleLinks": {
        "docs": "https://resend.com/changelog/remote-mcp-server"
      },
      "warnings": [
        "A Resend account with access to the relevant domains."
      ]
    }
  ]
}
